// src/components/shared/SingleScreenLayout.jsx
import React from "react";

export function SingleScreenLayout({ children }) {
  return (
    // this goes in the “1fr” slot of the grid above
    <main className="relative flex flex-col overflow-hidden">{children}</main>
  );
}

export function DefaultLayout({ children }) {
  return <main className="flex-1 overflow-auto">{children}</main>;
}
